/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState, useEffect, BaseSyntheticEvent } from 'react'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { Datatable } from '../../../../components/Datatable/Datatable'
import type { MetaType, OrderType } from '../../../../components/Datatable/Datatable'
import { Button } from '../../../../components/Button/Button'
import { useNavigate } from 'react-router-dom'
import { GET, PUT, POST, DELETE } from '../../../../services/api'
import useModals from '../../../../hooks/useModals'
import { Loading } from '../../../../components/Loading/Loading'
import { Dropdown } from 'react-bootstrap'
import { ModalWrapper } from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import { Input } from '../../../../components/Input/Input'
import Swal from 'sweetalert2'
import { i18n } from '../../../../translate/i18n'
import { ModalDelete } from '../../../../components/Modals/General/ModalDelete/ModalDelete'
import { BreadCrumbs } from '../../../../components/BreadCrumbs/breadCrumbrs'
import usePluginsSpace from '../../../../hooks/usePluginSpace'
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd'
import { EditCategoriaModal } from '../../../../components/Modals/Categorias/EditCategoria/EditCategoria'
import useAuth from '../../../../hooks/useAuth'

type CategoryType = {
  id: number
  parent: string
  code: string
  name: string
  shortname: string
  order: number
  img: string
  status: boolean
  subitems: CategoryType[]
  highlight: boolean
  showSubitem: boolean
}

type ConfigType = {
  id: number;
  type: string;
  content: {
    orderCategory: string;
  }
}

type PluginconfigType = {
  name: string;
  plugintemplateId: number;
  deleted: string;
}

const CategoriasContent: FC = () => {
  const navigate = useNavigate()
  const { showDeleteModal, showWrapperModal } = useModals()
  const {loginInfo} = useAuth()
  const {integrations} = usePluginsSpace()
  const [loading, setLoading] = useState(false)
  const [loadingTable, setLoadingTable] = useState(false)
  const [categories, setCategories] = useState<any[]>([])
  const [category, setCategory] = useState<any>(null)
  const [id, setId] = useState<number | null>(null)
  const [meta, setMeta] = useState<MetaType | undefined>(undefined)
  const [fileToImport, setFileToImport] = useState<File | null>(null)
  const [hasIntegration, setHasIntegration] = useState<'totvsFashionVarejo' | 'totvsFood' | 'none'>('none')
  const [confirmText, setConfirmText] = useState('')
  const [qtdCategorias, setqtdCategorias] = useState(0);
  const [deleteCategoryOrSub, setDeleteCategorOrSub] = useState<CategoryType>();

  const [showEditCategoriaModal, setShowEditCategoriaModal] = useState(false);

  const [listClassification, setListClassification] = useState<any[]>([])

  const [query, setQuery] = useState('');
  const [status, setStatus] = useState('all');

  const verifyChildAndSwitch = (category:CategoryType, Id: number) => {
    category.subitems.forEach((subcategory: CategoryType) => {
      if (subcategory.id === Id) {
        subcategory.status = !subcategory.status
      }
      if(subcategory.subitems && subcategory.subitems.length > 0)
        verifyChildAndSwitch(subcategory, Id)
    })
  }

  const switchStatus = async (Id: number, status: boolean) => {
    try {
      const switchClassification = await PUT(`/classification/${Id}`, {
        status: !status,
      })
      if (switchClassification.success) {
        const newCategories = categories.map((category:CategoryType) => {
          if (category.id === Id) {
            category.status = !status
          }
          if(category.subitems && category.subitems.length > 0)
            verifyChildAndSwitch(category, Id)
          return category
        })
        setCategories(newCategories)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const searchCategoryVerify = (category: CategoryType, search: string) => {
    if (category.name.toLowerCase().includes(search.toLowerCase())) {
      return true
    }
    let haveSubcategorySearch = false
    category.subitems.forEach((subcategory) => {
      if (subcategory.name.toLowerCase().includes(search.toLowerCase())) {
        haveSubcategorySearch = true
      } else {
        haveSubcategorySearch = searchCategoryVerify(subcategory, search)
      }
    })
    return haveSubcategorySearch
  }

  let filterData = (array: any, search: string, searchFields: any[]) => {
    const arrayCopy = JSON.parse(JSON.stringify(array))

    return arrayCopy.filter((item: any) => {
      let found = searchFields.some((field) => {
        return item[field].toLowerCase().indexOf(search.toLowerCase()) > -1
      })

      if (item.subitems.length > 0) {
        item.subitems = filterData(item.subitems, search, searchFields)
      }

      return found || item.subitems.length > 0
    })
  }

  const ordenationCategories = (newCategories: any) => {
    if (!Array.isArray(newCategories)) return [];

    return newCategories
      .map(category => {
        if (Array.isArray(category.subitems)) {
          category.subitems = ordenationCategories(category.subitems);
        }
        return category;
      })
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  const markShowSubitemsCategories = (newCategories: any) => {
    newCategories.forEach((category:any) => {
      category.showSubitem = true;
      if(category.subitems) markShowSubitemsCategories(category.subitems);
    });
    return newCategories;
  }

  const generateClassificationTree = (newCategories: any, parent: string | null, name: string): any => {
    const parentCategory = newCategories.find((newCategory: any) => newCategory.code === parent);
    if (parentCategory) return `${generateClassificationTree(newCategories, parentCategory.parent, parentCategory.name)} > ${name}`
    else return name;
  }

  const getCategories = async (take: number = 10, page: number = 1, search: string = '', order: OrderType = {field: 'name', type: 'ASC'}) => {
    try {
      const res = await GET(`/classification/categories?field=${order.field}&order=${order.type}`)
      const resSub = await GET(`/classification/`)

      const newCategories = res.data.map((row: CategoryType) => {
        return {
          id: row.id,
          name: `${row.name}`,
          status: row.status,
          code: row.code,
          parent: row.parent,
          order: row.order,
          img: row.img
        }
      })

      const newSubcategories = resSub.data.map((row: CategoryType) => {
        return {
          id: row.id,
          name: `${row.name}`,
          status: row.status,
          code: row.code,
          parent: row.parent,
          order: row.order,
          img: row.img
        }
      })

      newCategories.forEach((category: CategoryType) => {
        category.subitems = newSubcategories.filter(
          (categoryChild: CategoryType) =>
            categoryChild.parent === category.code && categoryChild.code !== category.code
        )
      })
      newSubcategories.forEach((category: CategoryType) => {
        category.subitems = newSubcategories.filter(
          (categoryChild: CategoryType) =>
            categoryChild.parent === category.code && categoryChild.code !== category.code
        )
      })
      const filterCategories = markShowSubitemsCategories(ordenationCategories(filterData(newCategories, search, ['name'])))
      
      setCategories(filterCategories)
      setqtdCategorias(resSub.meta.itemCount)

      setMeta(res.meta)

      const newListClassification: any[] = [];

      [...res.data, ...resSub.data].forEach((row: CategoryType) => {
        if(row.id !== id){
          newListClassification.push({
            id: row.id,
            parent: row.parent,
            code: row.code,
            name: generateClassificationTree([...res.data, ...resSub.data], row.parent, row.name),
          })
        }
      })

      const newCategoriesAll = [
        {
          code: '0',
          name: 'Selecione',
          key: -1,
        },
      ]
      newListClassification.forEach((row: any, idx) => {
        newCategoriesAll.push({
          code: row.code,
          name: row.name,
          key: idx,
        })
      })
      setListClassification(newCategoriesAll)
      
    } catch (e) {
      console.log(e)
    }
  }

  const verifyIntegration = async () => {
    
    try {
      const totvsIntegration = integrations.filter((pluginconfig: PluginconfigType) => pluginconfig.plugintemplateId === 23 || pluginconfig.plugintemplateId === 15 || pluginconfig.plugintemplateId === 45 || pluginconfig.plugintemplateId === 104)
      const totvsIntegrationFood = integrations.filter((pluginconfig: PluginconfigType) => pluginconfig.plugintemplateId === 48)
      if (totvsIntegration && totvsIntegration.length > 0) {
        setHasIntegration('totvsFashionVarejo');
      } else if (totvsIntegrationFood && totvsIntegrationFood.length > 0){
        setHasIntegration('totvsFood');
      }
    } catch (e) {
      setHasIntegration('none');
      console.log(e)
    }
  }

  const deleteCategory = async () => {
    try {
      if(!deleteCategoryOrSub?.parent && deleteCategoryOrSub?.subitems && deleteCategoryOrSub.subitems.length > 0){
        Swal.fire({
          icon: 'error',
          title: 'Não foi possível fazer a exclusão!',
          text: 'Existem subcategorias vinculadas a essa categoria, faça a atualização das subcategorias e depois tente novamente.',
        });
        return;
      }
      setLoading(true)
      const markRes = await DELETE(`/classification/${id}`)
      if (markRes.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Categoria deletada',
          text: 'Deleção realizada com sucesso!',
        }).then(async () => await getCategories())
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao deletar a categoria!',
        }).then(async () => await getCategories())
      }
      setLoading(false)
    } catch (e:any) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Não foi possível fazer a exclusão',
        text: e ? e : 'Erro ao deletar a categoria!',
      }).then(async () => await getCategories())
      console.log(e)
    }
  }

  const deleteAllCategories = async () => {
    try {
      setLoading(true)
      const markRes = await POST(`/classification/all`)

      if (markRes.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Categorias deletadas',
          text: 'Deleção realizada com sucesso!',
        }).then(async () => await getCategories())
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao deletar a categoria!',
        }).then(async () => await getCategories())
      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao deletar a categoria!',
      }).then(async () => await getCategories())
      console.log(e)
    }
  }

  const importCategories = async () => {

    try {
      if (!fileToImport) {
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se foi selecionado um arquivo!',
        })
      } else {
        setLoading(true)
        const formData = new FormData()
        formData.append('file', fileToImport)

        const importRes = await POST('/classification/import', formData)
        setLoading(false)
        if (importRes.success === true) {
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'Importação realizada com sucesso!',
          }).then(async () => await getCategories())
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao importar arquivo!',
          }).then(async () => await getCategories())
        }
      }
    } catch (e: any) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e,
      }).then(async () => await getCategories())
    }
    setFileToImport(null)
  }

  async function getAllData() {
    setLoading(true)
    await Promise.all([
      verifyIntegration(),
      getCategories()
    ])

    setLoading(false)
  }

  const verifyOrderRecursive = (ordersCategories: {id: number, order: number}[], categoriesToVerify: CategoryType[]) => {
    categoriesToVerify.forEach((ct, index) => {
      const findedIndex = ordersCategories.findIndex((orderCt) => orderCt.id === ct.id)
      if(findedIndex === -1 && ct.order !== index + 1){
        ordersCategories.push({
          order: index + 1,
          id: ct.id
        })
      }
      if(ct.subitems && ct.subitems.length > 0) verifyOrderRecursive(ordersCategories, ct.subitems);
    })
  }

  const verifyOrders = async (categoriesToVerify: CategoryType[]) => {
    let ordersCategories: {id: number, order: number}[]  = [];
    categoriesToVerify.forEach((ct, index) => {
        const findedIndex = ordersCategories.findIndex((orderCt) => orderCt.id === ct.id)
        if(findedIndex === -1 && ct.order !== index + 1){
          ordersCategories.push({
            order: index + 1,
            id: ct.id
          })
        }
        if(ct.subitems && ct.subitems.length > 0) verifyOrderRecursive(ordersCategories, ct.subitems);
    })
    if(ordersCategories.length > 0){
      setLoading(true);
      await POST(`/classification/order-classifications`, ordersCategories)
      setLoading(false);
    }
  }

  const onDragEnd = (res: DropResult, list: any, setList: any) => {
    if (!res.destination) return

    const { source, destination } = res;
    const copiedItems = [...list]

    const [removed] = copiedItems.splice(source.index, 1);

    copiedItems.splice(destination.index, 0, removed)
    
    verifyOrders(copiedItems)

    setList(copiedItems)
  }

  const onDragEndSubitems = (res: DropResult, list: any, setList: any, index: number, subitem: string) => {
    if (!res.destination) return

    const { source, destination } = res;
    const newList = [...list]
    const copiedItems = [...newList[index][subitem]]

    const [removed] = copiedItems.splice(source.index, 1);

    copiedItems.splice(destination.index, 0, removed)
    
    newList[index][subitem] = copiedItems
    verifyOrders(newList)
    setList(newList)
  }

  const generateSubitems = (subitems: CategoryType[], index: number, categoryId: number, marginLeft: number = 20, indexes:number[] = []) => {
    return (
      <DragDropContext onDragEnd={result => onDragEndSubitems(result, categories, setCategories, index, 'subitems')}>
        <Droppable droppableId={`category-${categoryId}`} type='group'>
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {subitems.map((subcategory: CategoryType, indexSubcategory: number) => (
                <div style={subcategory.highlight ? {backgroundColor: '#FAEFB5'} : { backgroundColor: '#FFF'}}>
                  <Draggable key={`subcategory-${subcategory.id}`} draggableId={`subcategory-${subcategory.id}`} index={indexSubcategory}>
                    {(provided) => (
                      <div 
                        className='flex-grow-1 d-flex justify-content-between fw-bolder text-muted py-5 border-bottom'
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div
                          className={'mx-1 d-flex align-items-center text-break px-0 '}
                          style={{width: '10%'}}
                        >
                          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.5938 24.7812H15.9062V23.4688H14.5938V24.7812ZM14.5938 25.875C13.9648 25.875 13.5 25.4102 13.5 24.7812V23.4688C13.5 22.8672 13.9648 22.375 14.5938 22.375H15.9062C16.5078 22.375 17 22.8672 17 23.4688V24.7812C17 25.4102 16.5078 25.875 15.9062 25.875H14.5938ZM19.8438 24.7812H21.1562V23.4688H19.8438V24.7812ZM19.8438 25.875C19.2148 25.875 18.75 25.4102 18.75 24.7812V23.4688C18.75 22.8672 19.2148 22.375 19.8438 22.375H21.1562C21.7578 22.375 22.25 22.8672 22.25 23.4688V24.7812C22.25 25.4102 21.7578 25.875 21.1562 25.875H19.8438ZM14.5938 19.0938V20.4062H15.9062V19.0938H14.5938ZM13.5 20.4062V19.0938C13.5 18.4922 13.9648 18 14.5938 18H15.9062C16.5078 18 17 18.4922 17 19.0938V20.4062C17 21.0352 16.5078 21.5 15.9062 21.5H14.5938C13.9648 21.5 13.5 21.0352 13.5 20.4062ZM19.8438 20.4062H21.1562V19.0938H19.8438V20.4062ZM19.8438 21.5C19.2148 21.5 18.75 21.0352 18.75 20.4062V19.0938C18.75 18.4922 19.2148 18 19.8438 18H21.1562C21.7578 18 22.25 18.4922 22.25 19.0938V20.4062C22.25 21.0352 21.7578 21.5 21.1562 21.5H19.8438ZM14.5938 14.7188V16.0312H15.9062V14.7188H14.5938ZM13.5 16.0312V14.7188C13.5 14.1172 13.9648 13.625 14.5938 13.625H15.9062C16.5078 13.625 17 14.1172 17 14.7188V16.0312C17 16.6602 16.5078 17.125 15.9062 17.125H14.5938C13.9648 17.125 13.5 16.6602 13.5 16.0312ZM19.8438 16.0312H21.1562V14.7188H19.8438V16.0312ZM19.8438 17.125C19.2148 17.125 18.75 16.6602 18.75 16.0312V14.7188C18.75 14.1172 19.2148 13.625 19.8438 13.625H21.1562C21.7578 13.625 22.25 14.1172 22.25 14.7188V16.0312C22.25 16.6602 21.7578 17.125 21.1562 17.125H19.8438Z" fill="#6E7586"/>
                          </svg>
                        </div>
                        <div
                          className={'mx-1 d-flex align-items-center text-break px-0 '}
                          style={{width: '45%'}}
                        >
                          <span className='text-dark fw-normal' style={{ marginLeft: `${marginLeft}px` }}>
                            {`${indexes.join('.')}.${indexSubcategory+1} ${subcategory.name}`}
                          </span>
                        </div>
                        <div
                          className={'mx-1 d-flex align-items-center text-break px-0 '}
                          style={{width: '15%'}}
                        >
                          <span className='text-dark fw-normal'>
                            {subcategory.code}
                          </span>
                        </div>
                        <div
                          className={'mx-1 d-flex align-items-center text-break px-0 '}
                          style={{width: '15%'}}
                        >
                          <span className='text-dark fw-normal'>
                            <Input
                              value={subcategory.status}
                              checked={subcategory.status}
                              change={() => switchStatus(subcategory.id, subcategory.status)}
                              inputAttr={{
                                type: 'checkbox',
                              }}
                              checkSwift={true}
                            />
                          </span>
                        </div>
                        <div
                          className={'mx-1 d-flex align-items-center text-break px-0 '}
                          style={{width: '15%'}}
                        >
                          <div
                            className={`d-flex align-items-center me-5 cursor-pointer`}
                            style={{whiteSpace: 'nowrap'}}
                          >
                            <i
                              title={'Editar Subcategoria'}
                              className={`fas fa-pen fs-4`}
                              onClick={() => {
                                setCategory(subcategory)
                                setShowEditCategoriaModal(true)
                              }}
                            ></i>
                          </div>
                          <div
                            className={`d-flex align-items-center me-5 text-hover-danger cursor-pointer`}
                            style={{whiteSpace: 'nowrap'}}
                          >
                            <i
                              title={'Excluir Subcategoria'}
                              className={`fas fa-trash fs-4`}
                              onClick={() => {
                                showDeleteModal('Excluir subcategoria')
                                setDeleteCategorOrSub(subcategory)
                                setId(subcategory.id)
                              }}
                            ></i>
                          </div>
                          {(subcategory.subitems && subcategory.subitems.length > 0) ?
                            <div
                              className={`d-flex align-items-center me-5 text-hover-danger cursor-pointer`}
                              style={{whiteSpace: 'nowrap'}}
                            >
                              <i
                                className={subcategory.showSubitem ? 'fas fa-chevron-down' : 'fas fa-chevron-right'}
                                onClick={() => {
                                  const newCategories = [...categories];
                                  if(indexes.length === 1){

                                    newCategories[indexes[0]-1].subitems[indexSubcategory].showSubitem = !newCategories[indexes[0]-1].subitems[indexSubcategory].showSubitem;
                                    setCategories(newCategories);
                                  }
                                }}
                              ></i>
                            </div>
                            : <></>}
                        </div>
                      </div>
                    )}
                  </Draggable>
                  {(subcategory.subitems && subcategory.subitems.length > 0 && subcategory.showSubitem) && (
                    generateSubitems(subcategory.subitems, indexSubcategory, subcategory.id, marginLeft + 20, [...indexes, indexSubcategory+1])
                  )}
                </div>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    )
  }

  const searchRecursive = (subcategories:any) => {
    let haveQuery = false;
    subcategories.forEach((sub:any) => {
      searchRecursive(sub.subitems);
      if(sub.name.toLowerCase().includes(query.toLowerCase())) {
        sub.highlight = query ? true : false;
        haveQuery = true;
      } else {
        sub.highlight = false;
      }
      if(sub.subitems && sub.subitems.length > 0 && !haveQuery) {
        sub.highlight = false;
        haveQuery = searchRecursive(sub.subitems);
      }
    })
    return haveQuery
  }

  const filterCategories = (categoriesToSearch: any) => {
    const filteredCategories = categoriesToSearch.filter((classification:any) => {
      let haveQuery = false
      searchRecursive(classification.subitems);

      if(classification.name.toLowerCase().includes(query.toLowerCase())){
        classification.highlight = query ? true : false;
        haveQuery = true;
      }  else{
        classification.highlight = false;
        haveQuery = false;
      }
      if(classification.subitems && classification.subitems.length > 0 && !haveQuery){
        classification.highlight = false;
        haveQuery = searchRecursive(classification.subitems);
      }
      return haveQuery;
    })

    if(status === 'true') return filteredCategories.filter((classification:any) => classification.status)
    else if(status === 'false') return filteredCategories.filter((classification:any) => classification.status === false)
    return filteredCategories;
  }

  const getTextDeleteCategory = () => {
    if(categories.length > 0){
      let categoryGeral = categories.find((cat) => cat.code === `C${loginInfo.pluginspaceId}C` || cat.code === '1' || cat.name.toLowerCase() === 'geral');
      if(!categoryGeral) categoryGeral = categories[0];
      if(deleteCategoryOrSub?.parent){
        return `Excluindo essa categoria, todos os produtos relacionados a ela vão para a ${categoryGeral.code} - ${categoryGeral.name}, deseja continuar?`
      } else {
        return `Categorias de nivel 1 só são permitidas serem deletadas caso não tiverem produtos atrelados a ela e nenhuma outra subcategoria vinculada. Você confirma a exclusão?`
      }
    } else return ''
  }
  
  useEffect(() => {
    if(!loadingTable){
      setLoadingTable(true)
      setTimeout(() => {
        setLoadingTable(false)
      }, 500)
    }
  }, [query])

  useEffect(() => {
    getAllData()
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>Categorias</span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  Aqui estão listadas as categorias juntamente com suas respectivas ações.
                </span>
              </h3>
              <div className='card-toolbar'>
                <Button
                  text='Adicionar categoria'
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate('/category/criar')}
                  btnClass='mb-5 fw-bolder'
                />
                {!hasIntegration && (
                  <Dropdown
                    className='btn btn-primary btn-sm fw-bolder me-5 p-0 mb-5'
                    style={{ marginLeft: '1em' }}
                  >
                    <Dropdown.Toggle variant='default' size='sm' >
                      <i className='bi bi-three-dots fs-4 p-0'></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='p-0'>
                      <Dropdown.Item
                        onClick={() => {
                          showWrapperModal('Importar CSV')
                        }}
                        className='p-0 d-flex flex-row justify-content-center'
                      >
                        <div className='btn m-4 d-flex flex-row justify-content-center align-items-center' style={{ color: '#6993FF', backgroundColor: '#E1E9FF', width: '90%' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-filetype-csv" viewBox="0 0 16 16"
                            style={{ color: '#6993FF', fontSize: '1.5rem', marginRight: '0.5em' }}>
                            <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z" />
                          </svg>
                          <p style={{ color: '#6993FF', fontSize: '1rem' }} className='m-0'>
                            Importar CSV
                          </p>
                        </div>
                      </Dropdown.Item>
                      {(qtdCategorias > 1) && (
                        <>
                          <Dropdown.Divider />
                          <Dropdown.Item
                            onClick={() => {
                              Swal.fire({
                                icon: 'warning',
                                title: `Atenção!`,
                                html: `
                              Cuidado ao realizar a exclusão, os dados não poderão ser <b>restaurados!<b/>
                              <div style="margin-top: 8">Digite <b>excluir</b> para confirmar!</div>`,
                                showCloseButton: true,
                                showConfirmButton: true,
                                confirmButtonColor: '#dc3741',
                                confirmButtonText: 'Excluir',
                                showCancelButton: false,
                                input: 'text',
                                inputPlaceholder: 'excluir',
                                preConfirm: (text) => {
                                  setConfirmText(text)
                                },
                              }).then(async (res) => {
                                if (res.isConfirmed && res.value && res.value === 'excluir') {
                                  await deleteAllCategories()
                                } else {
                                  Swal.close()
                                }
                              })
                            }}
                            className='p-0 d-flex flex-row justify-content-center'
                          >
                            <div className='btn m-4 d-flex flex-row justify-content-center align-items-center' style={{ color: '#F64E60', backgroundColor: '#FFE2E5', width: '90%' }}>
                              <i className="bi bi-x" style={{ color: '#F64E60', fontSize: '1.5rem', marginRight: '0.5em' }}></i>
                              <p style={{ color: '#F64E60', fontSize: '1rem' }} className='m-0'>
                                Excluir tudo
                              </p>
                            </div>
                          </Dropdown.Item>
                        </>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </div>
            <div className='card-body'>
              <div className='d-flex justify-content-between align-items-start mb-8'>
                <div className='col-3'>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    label='Status'
                    options={[
                      { select: i18n.t(`general.active`), value: 'true' },
                      { select: i18n.t(`general.inactive`), value: 'false' },
                      { select: i18n.t(`queue.all`), value: 'all' },
                    ]}
                    value={status}
                    change={(value: string) => setStatus(value)}
                  />
                </div>
                <div className='col-3 col-md-4 col-xl-5'>
                  <Input
                    value={query}
                    inputAttr={{
                      type: 'search',
                      name: 'search',
                    }}
                    change={setQuery}
                    placeholder={i18n.t(`buttons.search`)}
                  />
                </div>
              </div>
              <div className='table-responsive'>
                <div className='flex-grow-1 d-flex justify-content-between fw-bolder text-muted'>
                  <div
                    style={{width: '10%'}}
                    className={'x-1 text-uppercase cursor-pointer text-hover-primary px-0 d-flex flex-row align-items-center'}
                  >
                    <p style={{marginLeft: '1.2rem', marginBottom: 0}}>POSIÇÃO</p>
                  </div>
                  <div
                    style={{width: '45%'}}
                    className={'mx-1 text-uppercase cursor-pointer text-hover-primary px-0 d-flex flex-row align-items-center'}
                  >
                    NOME
                  </div>
                  <div
                    style={{width: '15%'}}
                    className={'mx-1 text-uppercase cursor-pointer text-hover-primary px-0 d-flex flex-row align-items-center'}
                  >
                    CÓDIGO
                  </div>
                  <div
                    style={{width: '15%'}}
                    className={'mx-1 text-uppercase cursor-pointer text-hover-primary px-0 d-flex flex-row align-items-center'}
                  >
                    STATUS
                  </div>
                  <div
                    style={{width: '15%'}}
                    className={'mx-1 text-uppercase cursor-pointer text-hover-primary px-0 d-flex flex-row align-items-center'}
                  >
                    AÇÕES
                  </div>
                </div>
                {loadingTable ? <Loading /> : (
                  <div className='flex-grow-1 d-flex justify-content-between fw-bolder text-muted'>
                    <DragDropContext onDragEnd={result => onDragEnd(result, categories, setCategories)}>
                      <Droppable droppableId="ROOT" type='group'>
                        {(provided, snapshot) => (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            className='flex-grow-1 d-flex w-100 flex-column'
                          >
                            {filterCategories(categories).map((category:any, index:number) => (
                              <div style={category.highlight ? {backgroundColor: '#FAEFB5'} : { backgroundColor: '#FFF'}}>
                                <Draggable key={category.id} draggableId={`category-${category.id}`} index={index}>
                                  {(provided) => (
                                    <div 
                                      className='flex-grow-1 d-flex justify-content-between fw-bolder text-muted py-5 border-bottom'
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div
                                        className={'mx-1 d-flex align-items-center text-break px-0 '}
                                        style={{width: '10%'}}
                                      >
                                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M14.5938 24.7812H15.9062V23.4688H14.5938V24.7812ZM14.5938 25.875C13.9648 25.875 13.5 25.4102 13.5 24.7812V23.4688C13.5 22.8672 13.9648 22.375 14.5938 22.375H15.9062C16.5078 22.375 17 22.8672 17 23.4688V24.7812C17 25.4102 16.5078 25.875 15.9062 25.875H14.5938ZM19.8438 24.7812H21.1562V23.4688H19.8438V24.7812ZM19.8438 25.875C19.2148 25.875 18.75 25.4102 18.75 24.7812V23.4688C18.75 22.8672 19.2148 22.375 19.8438 22.375H21.1562C21.7578 22.375 22.25 22.8672 22.25 23.4688V24.7812C22.25 25.4102 21.7578 25.875 21.1562 25.875H19.8438ZM14.5938 19.0938V20.4062H15.9062V19.0938H14.5938ZM13.5 20.4062V19.0938C13.5 18.4922 13.9648 18 14.5938 18H15.9062C16.5078 18 17 18.4922 17 19.0938V20.4062C17 21.0352 16.5078 21.5 15.9062 21.5H14.5938C13.9648 21.5 13.5 21.0352 13.5 20.4062ZM19.8438 20.4062H21.1562V19.0938H19.8438V20.4062ZM19.8438 21.5C19.2148 21.5 18.75 21.0352 18.75 20.4062V19.0938C18.75 18.4922 19.2148 18 19.8438 18H21.1562C21.7578 18 22.25 18.4922 22.25 19.0938V20.4062C22.25 21.0352 21.7578 21.5 21.1562 21.5H19.8438ZM14.5938 14.7188V16.0312H15.9062V14.7188H14.5938ZM13.5 16.0312V14.7188C13.5 14.1172 13.9648 13.625 14.5938 13.625H15.9062C16.5078 13.625 17 14.1172 17 14.7188V16.0312C17 16.6602 16.5078 17.125 15.9062 17.125H14.5938C13.9648 17.125 13.5 16.6602 13.5 16.0312ZM19.8438 16.0312H21.1562V14.7188H19.8438V16.0312ZM19.8438 17.125C19.2148 17.125 18.75 16.6602 18.75 16.0312V14.7188C18.75 14.1172 19.2148 13.625 19.8438 13.625H21.1562C21.7578 13.625 22.25 14.1172 22.25 14.7188V16.0312C22.25 16.6602 21.7578 17.125 21.1562 17.125H19.8438Z" fill="#6E7586"/>
                                        </svg>
                                      </div>
                                      <div
                                        className={'mx-1 d-flex align-items-center text-break px-0 '}
                                        style={{width: '45%'}}
                                      >
                                        <span className='text-dark fw-normal'>
                                          {`${index + 1} ${category.name}`}
                                        </span>
                                      </div>
                                      <div
                                        className={'mx-1 d-flex align-items-center text-break px-0 '}
                                        style={{width: '15%'}}
                                      >
                                        <span className='text-dark fw-normal'>
                                          {category.code}
                                        </span>
                                      </div>
                                      <div
                                        className={'mx-1 d-flex align-items-center text-break px-0 '}
                                        style={{width: '15%'}}
                                      >
                                        <span className='text-dark fw-normal'>
                                          <Input
                                            value={category.status}
                                            checked={category.status}
                                            change={() => switchStatus(category.id, category.status)}
                                            inputAttr={{
                                              type: 'checkbox',
                                            }}
                                            checkSwift={true}
                                          />
                                        </span>
                                      </div>
                                      <div
                                        className={'mx-1 d-flex align-items-center text-break px-0 '}
                                        style={{width: '15%'}}
                                      >
                                        <div
                                          className={`d-flex align-items-center me-5 cursor-pointer`}
                                          style={{whiteSpace: 'nowrap'}}
                                        >
                                          <i
                                            title={'Editar Categoria'}
                                            className={`fas fa-pen fs-4`}
                                            onClick={() => {
                                              setCategory(category)
                                              setShowEditCategoriaModal(true)
                                            }}
                                          ></i>
                                        </div>
                                        <div
                                          className={`d-flex align-items-center me-5 text-hover-danger cursor-pointer`}
                                          style={{whiteSpace: 'nowrap'}}
                                        >
                                          <i
                                            title={'Excluir Categoria'}
                                            className={`fas fa-trash fs-4`}
                                            onClick={() => {
                                              showDeleteModal('Excluir categoria')
                                              setDeleteCategorOrSub(category)
                                              setId(category.id)
                                            }}
                                          ></i>
                                        </div>
                                        {(category.subitems && category.subitems.length > 0) ?
                                        <div
                                          className={`d-flex align-items-center me-5 text-hover-danger cursor-pointer`}
                                          style={{whiteSpace: 'nowrap'}}
                                        >
                                          <i
                                            className={category.showSubitem ? 'fas fa-chevron-down' : 'fas fa-chevron-right'}
                                            onClick={() => {
                                              const newCategories = [...categories];
                                              newCategories[index].showSubitem = !newCategories[index].showSubitem;
                                              setCategories(newCategories)
                                            }}
                                          ></i>
                                        </div>
                                        : <></>}
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                                {(category.subitems.length > 0 && category.showSubitem) && (
                                  generateSubitems(category.subitems, index, category.id, 20, [index+1])
                                )}
                              </div>
                            ))}

                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>
                )}
              </div>
            </div>
          </div>
          {showEditCategoriaModal && (
            <EditCategoriaModal
              onCloseAction={() => {
                setShowEditCategoriaModal(false)
                setCategory(null)
              }}
              reloadAction={getCategories}
              setLoading={setLoading}
              category={category}
              categories={listClassification}
              integration={hasIntegration}
            />
          )}
          <ModalDelete
            customText={getTextDeleteCategory()}
            confirmAction={() => deleteCategory()}
          />
          <ModalWrapper
            confirmAction={() => importCategories()}
          >

            <div className='flex-grow-1'>
              <p>Atenção</p>
              <p>
                Para importar categorias, a primeira linha do arquivo tem que seguir os seguintes
                padrãos:
              </p>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                <div style={{ width: '30%' }}>
                  <Button
                    text={'Modelo'}
                    color='primary'
                    iconColor='#FFF'
                    size='small'
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => {
                      window.open('/file/modelo-categorias.xlsx', '')
                    }}
                    btnClass='fw-bolder me-5'
                  />
                </div>
              </div>
            </div>
            <br />
            <div className='flex-grow-1 text-center'>
              <Input
                inputAttr={{
                  type: 'file',
                }}
                acceptFile={'.xlsx,.xls'}
                change={(value: BaseSyntheticEvent) =>
                  setFileToImport(value ? value.target.files[0] : null)
                }
              />
            </div>
          </ModalWrapper>
        </div>
      )}
    </>
  )
}

const NewCategorias: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          { title: 'Dashboard', path: 'dashboard', isActive: true },
          { title: 'Categorias', path: 'category', isActive: true },
        ]}
      >
        Categorias
      </PageTitle>
      <CategoriasContent />
    </>
  )
}

export { NewCategorias }
